import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=5f7eb79b&scoped=true"
import script from "./QuotesList.vue?vue&type=script&lang=js"
export * from "./QuotesList.vue?vue&type=script&lang=js"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=5f7eb79b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7eb79b",
  null
  
)

export default component.exports